/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M20.4197 16C20.5431 15.8341 20.659 15.6671 20.7674 15.5C21.6051 14.2091 22 12.9071 22 12C22 9.5 19 4 12 4C10.903 4 9.90427 4.13507 8.99991 4.3725C8.82995 4.41712 8.66332 4.46536 8.5 4.517"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M3 3L5.82578 5.82578M21 21L18.1742 18.1742M18.1742 18.1742C16.6292 19.2482 14.588 20 12 20C5 20 2 14.5 2 12C2 10.4243 3.19179 7.65676 5.82578 5.82578M18.1742 18.1742L14.1213 14.1213M5.82578 5.82578L9.87863 9.87863M9.87863 9.87863C9.33571 10.4215 8.99991 11.1715 8.99991 12C8.99991 13.6569 10.3431 15 11.9999 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M9.87863 9.87863L14.1213 14.1213"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 11.9999C2 14.4999 5 19.9999 12 19.9999C14.588 19.9999 16.6292 19.2481 18.1742 18.1741L14.1213 14.1212C13.5784 14.6641 12.8284 14.9999 11.9999 14.9999C10.3431 14.9999 8.99991 13.6568 8.99991 11.9999C8.99991 11.1715 9.33571 10.4214 9.87863 9.87854L5.82578 5.82568C3.19179 7.65667 2 10.4242 2 11.9999Z"
				fill="currentColor"
			/>
			<path
				d="M3 3L5.82578 5.82578M21 21L18.1742 18.1742M18.1742 18.1742C16.6292 19.2482 14.588 20 12 20C5 20 2 14.5 2 12C2 10.4243 3.19179 7.65676 5.82578 5.82578M18.1742 18.1742L14.1213 14.1213M5.82578 5.82578L9.87863 9.87863M9.87863 9.87863C9.33571 10.4215 8.99991 11.1715 8.99991 12C8.99991 13.6569 10.3431 15 11.9999 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M9.87863 9.87863L14.1213 14.1213M20.4197 16C20.5431 15.8341 20.659 15.6671 20.7674 15.5C21.6051 14.2091 22 12.9071 22 12C22 9.5 19 4 12 4C10.903 4 9.90427 4.13507 8.99991 4.3725C8.82995 4.41712 8.66332 4.46536 8.5 4.517"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L4.68861 5.74927C2.36419 7.67946 1.25 10.3097 1.25 12C1.25 13.485 2.10654 15.663 3.83476 17.4577C5.5928 19.2834 8.28446 20.75 12 20.75C14.4611 20.75 16.4783 20.1062 18.0737 19.1343L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L18.7046 17.6439L6.35611 5.29545L3.53033 2.46967ZM14.068 15.1286L12.97 14.0306C12.6762 14.1712 12.3473 14.2499 11.9999 14.2499C10.7573 14.2499 9.74991 13.2425 9.74991 11.9999C9.74991 11.6525 9.82862 11.3236 9.96919 11.0298L8.87121 9.93187C8.47857 10.5247 8.24991 11.2356 8.24991 11.9999C8.24991 14.071 9.92884 15.7499 11.9999 15.7499C12.7642 15.7499 13.4751 15.5213 14.068 15.1286ZM9.19036 5.09792C10.0305 4.87735 10.9651 4.75 12 4.75C15.2845 4.75 17.5928 6.03338 19.0848 7.58273C20.6065 9.16305 21.25 10.985 21.25 12C21.25 12.7242 20.9206 13.886 20.1383 15.0918C20.0385 15.2456 19.9317 15.3994 19.8179 15.5524C19.5707 15.8847 19.6397 16.3546 19.9721 16.6018C20.3044 16.849 20.7743 16.78 21.0215 16.4476C21.1545 16.2688 21.2795 16.0887 21.3966 15.9082C22.2895 14.5321 22.75 13.0899 22.75 12C22.75 10.515 21.8935 8.33695 20.1652 6.54227C18.4072 4.71662 15.7155 3.25 12 3.25C10.8409 3.25 9.77804 3.3928 8.80946 3.64709C8.62754 3.69485 8.44903 3.74652 8.27391 3.80189C7.87897 3.92675 7.66002 4.34814 7.78489 4.74309C7.90975 5.13803 8.33114 5.35697 8.72609 5.23211C8.87761 5.1842 9.03236 5.1394 9.19036 5.09792Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 3L5.82578 5.82578M21 21L18.1742 18.1742M18.1742 18.1742C16.6292 19.2482 14.588 20 12 20C10.1455 20 8.57181 19.614 7.26022 19M18.1742 18.1742L14.1213 14.1213M5.82578 5.82578C3.19179 7.65676 2 10.4243 2 12C2 13.0245 2.50382 14.5528 3.58028 16M5.82578 5.82578L9.87863 9.87863M9.87863 9.87863C9.33571 10.4215 8.99991 11.1715 8.99991 12C8.99991 13.6569 10.3431 15 11.9999 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M9.87863 9.87863L14.1213 14.1213M20.4197 16C20.5431 15.8341 20.659 15.6671 20.7674 15.5C21.6051 14.2091 22 12.9071 22 12C22 9.5 19 4 12 4C10.903 4 9.90427 4.13507 8.99991 4.3725C8.82995 4.41712 8.66332 4.46536 8.5 4.517"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 3L5.82578 5.82578M21 21L18.1742 18.1742M18.1742 18.1742C16.6292 19.2482 14.588 20 12 20C5 20 2 14.5 2 12C2 10.4243 3.19179 7.65676 5.82578 5.82578M18.1742 18.1742L14.1213 14.1213M5.82578 5.82578L9.87863 9.87863M9.87863 9.87863C9.33571 10.4215 8.99991 11.1715 8.99991 12C8.99991 13.6569 10.3431 15 11.9999 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M9.87863 9.87863L14.1213 14.1213M20.4197 16C20.5431 15.8341 20.659 15.6671 20.7674 15.5C21.6051 14.2091 22 12.9071 22 12C22 9.5 19 4 12 4C10.903 4 9.90427 4.13507 8.99991 4.3725C8.82995 4.41712 8.66332 4.46536 8.5 4.517"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M2 11.9999C2 14.4999 5 19.9999 12 19.9999C14.588 19.9999 16.6292 19.2481 18.1742 18.1741L5.82578 5.82568C3.19179 7.65667 2 10.4242 2 11.9999Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L4.68861 5.74927C2.36419 7.67946 1.25 10.3097 1.25 12C1.25 13.485 2.10654 15.663 3.83476 17.4577C5.5928 19.2834 8.28446 20.75 12 20.75C14.4611 20.75 16.4783 20.1062 18.0737 19.1343L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L18.7046 17.6439L6.35611 5.29545L3.53033 2.46967ZM2.75 12C2.75 10.7939 3.65136 8.50541 5.75447 6.81513L9.41527 10.4759C9.15136 10.9226 8.99991 11.4436 8.99991 11.9999C8.99991 13.6568 10.3431 14.9999 11.9999 14.9999C12.5563 14.9999 13.0772 14.8485 13.5239 14.5845L16.9768 18.0374C15.6642 18.7655 14.0186 19.25 12 19.25C8.71554 19.25 6.4072 17.9666 4.91524 16.4173C3.39346 14.837 2.75 13.015 2.75 12ZM9.19036 5.09792C10.0305 4.87735 10.9651 4.75 12 4.75C15.2845 4.75 17.5928 6.03338 19.0848 7.58273C20.6065 9.16305 21.25 10.985 21.25 12C21.25 12.7242 20.9206 13.886 20.1383 15.0918C20.0385 15.2456 19.9317 15.3994 19.8179 15.5524C19.5707 15.8847 19.6397 16.3546 19.9721 16.6018C20.3044 16.849 20.7743 16.78 21.0215 16.4476C21.1545 16.2688 21.2795 16.0887 21.3966 15.9082C22.2895 14.5321 22.75 13.0899 22.75 12C22.75 10.515 21.8935 8.33695 20.1652 6.54227C18.4072 4.71662 15.7155 3.25 12 3.25C10.8409 3.25 9.77804 3.3928 8.80946 3.64709C8.62754 3.69485 8.44903 3.74652 8.27391 3.80189C7.87897 3.92675 7.66002 4.34814 7.78489 4.74309C7.90975 5.13803 8.33114 5.35697 8.72609 5.23211C8.87761 5.1842 9.03236 5.1394 9.19036 5.09792Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
